import {
	CallInteractionContent,
	InteractionBar,
	CrmCasePicker,
} from "@/components/molecules/interactionWorkspace";
import { InteractionType } from "@/common/types";
import {
	CallSessionState,
	useCallSessionStore,
} from "@/common/stores/nonpersistingStores/callSession";
import { AgentInteractionStatus } from "@/common/constants/callSession";
import { setCrmSelectedCases } from "@/repository/queryFns/call";

export const CallInteractionPanel = () => {
	const callSession = useCallSessionStore(
		(state: CallSessionState) => state.callSession
	);

	// Selected cases are pushed to Salesforce at call-end (CallTerminated), so the picker is
	// only meaningful while the call is live. Once terminated (wrap-up) we hide it: a late,
	// out-of-band CallSessionChanged notification (notably the async outbound queue lookup)
	// would otherwise toggle the section back on after it disappeared, causing a flicker that
	// inbound — where the context is set during the IVR before answer — never exhibits.
	const isCallTerminated =
		callSession?.state === AgentInteractionStatus.Terminated;

	// A supervisor monitoring the call sees the caller's Salesforce context but must not be
	// able to change the handling agent's case selection — render the picker read-only.
	const isMonitoring =
		callSession?.state === AgentInteractionStatus.Monitoring ||
		callSession?.state === AgentInteractionStatus.MonitoringStarting;

	return (
		<>
			<InteractionBar type={InteractionType.Call} />
			{/* Always mounted; hides ITSELF (renders null) once the call terminates instead of
			   being conditionally unmounted here — matches the messaging panel, where the
			   parent-driven unmount during the wrap-up transition stranded the picker's DOM in
			   the workspace. See the hidden prop doc on CrmCasePicker.
			   Key on the call id so the picker's internal state (selected cases, per-match
			   expansion, the seen/dirty refs) is reset between calls rather than leaking from
			   one interaction into the next. */}
			<CrmCasePicker
				key={callSession?.id}
				sfCtx={callSession?.crmCallerContext}
				onSaveSelectedCases={setCrmSelectedCases}
				readOnly={isMonitoring}
				hidden={isCallTerminated}
			/>
			<CallInteractionContent />
		</>
	);
};
